import { folderDetailsActionTypes } from './Constants';

const initialState = {
	loading: true,
	practiceableItems: [],
	isOpenAddListModal: false,
	addListModalLoading: false,
	isShared: true,
	isOwnFolder: true,
};

export default function folderDetailsReducer(state = initialState, action) {
	const { type, payload } = action;
	const { data, status } = payload || {};

	switch (type) {
		case folderDetailsActionTypes.GET_FOLDER_DETAILS_REQUEST:
		case folderDetailsActionTypes.UPDATE_FOLDER_REQUEST:
		case folderDetailsActionTypes.DELETE_FOLDER_REQUEST:
		case folderDetailsActionTypes.DELETE_LIST_FROM_FOLDER_REQUEST:
			return {
				...state,
				loading: true,
			};

		case folderDetailsActionTypes.CLEAR_FOLDER_DETAILS:
			return {
				...initialState,
			};

		case folderDetailsActionTypes.GET_FOLDER_DETAILS_SUCCESS:
			return {
				loading: false,
				...data,
				isOpenAddListModal: false,
				isShared: data.shared || false,
				isOwnFolder: data.is_own_folder || false,
				practiceableItems: data.practiceable_items || [],
			};

		case folderDetailsActionTypes.UPDATE_FOLDER_SUCCESS:
			return {
				...state,
				loading: false,
				name: data.name,
				shared: data.shared,
			};

		case folderDetailsActionTypes.DELETE_FOLDER_ERROR:
		case folderDetailsActionTypes.DELETE_LIST_FROM_FOLDER_ERROR:
		case folderDetailsActionTypes.UPDATE_FOLDER_ERROR:
		case folderDetailsActionTypes.FOLDER_ADD_ITEMS_ERROR:
		case folderDetailsActionTypes.GET_FOLDER_DETAILS_ERROR:
			return {
				...state,
				loading: false,
			};

		case folderDetailsActionTypes.TOGGLE_FOLDER_ADD_LIST_MODAL:
			return {
				...state,
				isOpenAddListModal: status,
			};

		case folderDetailsActionTypes.FOLDER_ADD_ITEMS_REQUEST:
			return {
				...state,
				addListModalLoading: true,
			};

		case folderDetailsActionTypes.FOLDER_ADD_ITEMS_SUCCESS:
			return {
				...state,
				addListModalLoading: false,
				isOpenAddListModal: false,
			};

		default:
			return state;
	}
}
